export class LandedCostsDtoModel {
    generic_doc_line_guid: string;
    landed_cost_amount: number;
}
  